import { executeApiCall, SuccessData } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { TaskFile } from '../types';
import { UploadedFile } from 'types';
import { uploadMutations } from 'entities/modules/uploads';

export const taskFileMutations = getMutations({
  uploadTaskFile: {
    action: async (payload: {
      project: string;
      task: string;
      files: UploadedFile[];
    }): Promise<TaskFile[]> => {
      return executeApiCall({
        method: 'post',
        path: 'projects/tasks/files',

        payload,
      });
    },

    messages: {
      suppressSuccess: true,

      error: (t) => ({
        title: t('could-not-add-files-to-task'),
        description: t('try-again-in-a-few-moments') as string,
        type: 'error',
      }),
    },
  },

  renameTaskFile: {
    action: async (payload: {
      projectId: string;
      taskId: string;
      fileId: string;
      name: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        method: 'post',
        path: 'projects/tasks/files/rename',

        payload,
      });
    },
  },

  newTaskFileVersion: {
    action: async ({
      file,
      name,
      ...params
    }: {
      projectId: string;
      taskId: string;
      fileId: string;
      name?: string;
      file: File;
    }): Promise<TaskFile> => {
      const { url } = await uploadMutations.uploadFile.action({
        file,
        prefix: `projects/${params.projectId}`,
      });

      return executeApiCall({
        method: 'post',
        path: 'projects/tasks/files/version',

        payload: {
          ...params,

          file: {
            url,
            filename: file.name,
            contentType: file.type,
            name,
          },
        },
      });
    },
  },
});
